export const defaultErrorMessage = `Oups ! Une erreur s'est produite !`
